import { IPieChartData } from '../../../interfaces/charts';
import { useMemo } from 'react';
import { sum } from 'lodash';

export const usePieChartSum = (data: IPieChartData[]) => {
  return useMemo(() => {
    return sum(data.map((p) => p.value));
  }, [data]);
};
